import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error module not typed
import ThreadViewMessagePlaceholder from '../../thread-view/components/ThreadViewMessagePlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadHistorySkeletonState = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    backgroundColor: "fill-surface-recessed",
    children: [/*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {}), /*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {}), /*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {})]
  });
};
ThreadHistorySkeletonState.displayName = 'ThreadHistorySkeletonState';
export default ThreadHistorySkeletonState;